import * as THREE from 'three';
import * as CANNON from 'cannon-es';

export function threeVector(vec) {
	return new THREE.Vector3(vec.x, vec.y, vec.z);
}

export function cannonVector(vec) {
	return new CANNON.Vec3(vec.x, vec.y, vec.z);
}

export function threeQuat(quat) {
	return new THREE.Quaternion(quat.x, quat.y, quat.z, quat.w);
}
export function createCapsuleCollider(radius, height, options) {
	// The height of the cylinder part is the total height minus the radius of the two spheres.
	const cylinderHeight = height - (radius * 2);

	// --- Create the Body ---
	const body = new CANNON.Body(options);

	// --- Create the Shapes ---
	// Note: The CANNON.Cylinder shape has its height along the Y axis by default.
	const cylinderShape = new CANNON.Cylinder(radius, radius, cylinderHeight, 12);
	const topSphereShape = new CANNON.Sphere(radius);
	const bottomSphereShape = new CANNON.Sphere(radius);

	// --- Add the shapes to the compound body ---
	// The cylinder is at the center of the body.
	body.addShape(cylinderShape, new CANNON.Vec3(0, 0, 0));

	// The spheres are offset vertically from the center.
	// The offset is half the height of the cylinder part.
	const sphereOffset = cylinderHeight / 2;
	body.addShape(topSphereShape, new CANNON.Vec3(0, sphereOffset, 0));
	body.addShape(bottomSphereShape, new CANNON.Vec3(0, -sphereOffset, 0));

	return body;
}